import { Collapse, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import TruestedSection from "../components/v4/TrustedSection/TruestedSection";
import LazyImage from "../components/v4/LazyLoadImage/LazyImage";
import LottieIcon from "../components/v4/LottieIcon";
import FaqSection from "../components/v4/FaqSection/FaqSection";
import Link from "../components/v2/Link";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";

import greenCheckCircle from "../images/v4/whatsappPage/icons/greenCheckCircle.svg";

import customerSupportHeroBg from "../images/v4/customerAiSupport/images/customerSupportHeroBg.png";
import heroSectionImg from "../images/v4/customerAiSupport/images/heroSectionImg.webp";

import bannerImg from "../images/v4/customerAiSupport/images/bannerImg.webp";

import keyFeatureBg from "../images/v4/customerAiSupport/images/keyFeatureBg.png";
import tabsSectionBg from "../images/v4/customerAiSupport/images/tabsSectionBg.png";
import benefitBg from "../images/v4/customerAiSupport/images/benefitBg.png";
import experienceBg from "../images/v4/customerAiSupport/images/experienceBg.png";
import cardImg1 from "../images/v4/customerAiSupport/images/cardImg1.webp";
import cardImg2 from "../images/v4/customerAiSupport/images/cardImg2.webp";
import keyImg from "../images/v4/customerAiSupport/images/keyImage.webp";

import heroIcon1 from "../images/v4/customerAiSupport/icons/heroIcon1.svg";
import heroIcon2 from "../images/v4/customerAiSupport/icons/heroIcon2.svg";
import heroIcon3 from "../images/v4/customerAiSupport/icons/heroIcon3.svg";

import keyIcon1 from "../images/v4/customerAiSupport/icons/keyIcon1.svg";
import keyIcon2 from "../images/v4/customerAiSupport/icons/keyIcon2.svg";
import keyIcon3 from "../images/v4/customerAiSupport/icons/keyIcon3.svg";
import keyIcon4 from "../images/v4/customerAiSupport/icons/keyIcon4.svg";
import keyIcon5 from "../images/v4/customerAiSupport/icons/keyIcon5.svg";
import keyIcon6 from "../images/v4/customerAiSupport/icons/keyIcon6.svg";

import benefitIcon1 from "../images/v4/customerAiSupport/icons/benefitIcon1.svg";
import benefitIcon2 from "../images/v4/customerAiSupport/icons/benefitIcon2.svg";
import benefitIcon3 from "../images/v4/customerAiSupport/icons/benefitIcon3.svg";
import benefitIcon4 from "../images/v4/customerAiSupport/icons/benefitIcon4.svg";
import benefitIcon5 from "../images/v4/customerAiSupport/icons/benefitIcon5.svg";
import benefitIcon6 from "../images/v4/customerAiSupport/icons/benefitIcon6.svg";

import realWorldImg1 from "../images/v4/customerAiSupport/images/realWorldImg1.webp";
import realWorldImg2 from "../images/v4/customerAiSupport/images/realWorldImg2.webp";
import realWorldImg3 from "../images/v4/customerAiSupport/images/realWorldImg3.webp";
import realWorldImg4 from "../images/v4/customerAiSupport/images/realWorldImg4.webp";
import realWorldImg5 from "../images/v4/customerAiSupport/images/realWorldImg5.webp";

import expIcon1 from "../images/v4/customerAiSupport/icons/expIcon1.svg";
import expIcon2 from "../images/v4/customerAiSupport/icons/expIcon2.svg";
import expIcon3 from "../images/v4/customerAiSupport/icons/expIcon3.svg";
import expIcon4 from "../images/v4/customerAiSupport/icons/expIcon4.svg";
import expIcon5 from "../images/v4/customerAiSupport/icons/expIcon5.svg";

import partnerIcon1 from "../images/v4/aiPage/icons/partnerIcon1.png";
import partnerIcon2 from "../images/v4/aiPage/icons/partnerIcon2.png";
import partnerIcon3 from "../images/v4/aiPage/icons/partnerIcon3.png";
import partnerIcon5 from "../images/v4/aiPage/icons/partnerIcon5.png";
import partnerIcon6 from "../images/v4/aiPage/icons/partnerIcon6.png";
import partnerIcon7 from "../images/v4/aiPage/icons/partnerIcon7.png";
import partnerIcon8 from "../images/v4/aiPage/icons/partnerIcon8.png";

import experienceImg2 from "../images/v4/customerAiSupport/images/experienceImg2.webp";
import experienceImg3 from "../images/v4/customerAiSupport/images/experienceImg3.webp";
import experienceImg4 from "../images/v4/customerAiSupport/images/experienceImg4.webp";
import experienceImg5 from "../images/v4/customerAiSupport/images/experienceImg5.webp";
import experienceImg6 from "../images/v4/customerAiSupport/images/experienceImg6.webp";

import SEO from "../components/SEO";

const useStyles = makeStyles(() => ({
  heroSectionOuter: {
    backgroundImage: `url(${customerSupportHeroBg})`,
    backgroundPosition: "top",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  },
  heroSection: {
    paddingTop: "100px",
    "@media only screen and (max-width: 600px)": {
      paddingTop: "0",
    },
  },
  heroSectionContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "50px",
    },
  },
  leftContainer: {
    width: "50%",
    gap: "16px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  leftBody: {
    gap: "16px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    "& span": {
      background: "linear-gradient(91deg, #5FFFFF 1.68%, #B458FF 99.86%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
  },
  rightContainer: {
    width: "45%",
    display: "flex",
    alignItems: "stretch",
    justifyContent: "flex-start",
    gap: "24px",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      flexDirection: "column",
      "& .heroSectionImg": {
        display: "none !important",
      },
    },
  },

  boxes: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      flexDirection: "row",
      gap: "12px",
    },
  },
  box: {
    gap: "38px",
    padding: "16px",
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    backdropFilter: "blur(50px)",
    "&:first-child": {
      background: "#4F1F75",
    },
    "&:nth-child(2)": {
      background: "#174C79",
    },
    "&:last-child": {
      background: "#104F4F",
    },
    "@media only screen and (max-width: 600px)": {
      flex: "1",
      padding: "10px",
      justifyContent: "center",
      alignItems: "flex-start",
      gap: "20px",
    },
  },
  bannerSection: {
    // background: "#001C22",
    "& img": {
      width: "100%",
    },
  },
  cardsSection: {
    // backgroundImage: `url(${cardsBg})`,
    // backgroundPosition: "top",
    // backgroundSize: "cover",
    // backgroundRepeat: "no-repeat",
    "& .centerContainer": {
      width: "80%",
      textAlign: "center",
      margin: "0 auto",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
        // textAlign: "left",
      },
    },
  },
  cards: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "100%",
    gap: "50px",
  },
  card: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "16px",
      "&:last-child": {
        flexDirection: "column-reverse",
      },
    },
  },
  cardLeftContainer: {
    width: "45%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "32px",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  cardRightContainer: {
    width: "45%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  keyFeature: {
    backgroundImage: `url(${keyFeatureBg})`,
    backgroundPosition: "top",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    "& .centerContainer": {
      width: "80%",
      textAlign: "center",
      margin: "0 auto",
      display: "flex",
      gap: "32px",
      flexDirection: "column",
      justifyContent: "flex-start",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  keyFeatureContainer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
    background: "#fff",
    padding: "32px",
    borderRadius: "24px",
    marginTop: "60px",
    "& .keyImg": {
      width: "32%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "32px",
      padding: "16px",
      flexDirection: "column",
      "& .keyImg": {
        width: "100%",
        display: "none",
      },
    },
  },
  keyBlock: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "32%",
    gap: "32px",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  keyBox: {
    width: "100%",
    gap: "16px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      gap: "12px",
    },
  },
  benefitSection: {
    backgroundImage: `url(${benefitBg})`,
    backgroundPosition: "top",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    paddingBottom: "260px",
    "& .centerContainer": {
      width: "100%",
      textAlign: "center",
      margin: "0 auto",
    },
    "& .trustedHeading": {
      width: "80%",
      textAlign: "center",
      margin: "0 auto",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "210px",
    },
  },
  benefitContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "24px",
    rowGap: "24px",
    margin: "60px 0",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "32px",
    },
  },
  benefitBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "24px",
    width: "32%",
    padding: "24px",
    borderRadius: "16px",
    transition: "0.3s ease",
    background: "transparent",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "12px",
      padding: "0",
    },
    "&:hover": {
      transition: "0.3s ease",
      background: "linear-gradient(117deg, #F2E1FF 0.97%, #E9FFFF 100%)",
      "@media only screen and (max-width: 600px)": {
        "&:hover": {
          background: "transparent",
        },
      },
    },
  },
  partnerSlide: {
    width: "144px !important",
    "& img": {
      width: "144px",
      filter: "brightness(0)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "max-content !important",
      "& img": {
        width: "100px",
      },
    },
  },
  partnerSlider: {
    padding: "10px 0 60px !important",
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "40px !important",
    },
  },
  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "-20%",
    "@media only screen and (max-width: 600px)": {
      top: "-15%",
    },
  },
  tabsSection: {
    backgroundImage: `url(${tabsSectionBg})`,
    backgroundPosition: "top",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    position: "relative",
    background: "#E0EFFD",
    paddingTop: "300px",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "100%",
      margin: "0 auto",
      textAlign: "center",
      "& h2": {
        width: "80%",
        "@media only screen and (max-width: 600px)": {
          width: "100%",
        },
      },
      "& p": {
        width: "80%",
        "@media only screen and (max-width: 600px)": {
          width: "100%",
        },
      },
    },
    "& $supportBox": {
      position: "absolute",
      top: "-530px",
      "@media only screen and (max-width: 600px)": {
        top: "-800px",
        marginTop: 0,
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "120px",
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  tabsContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    border: "2px solid #DBDBDB",
    borderRadius: "40px",
    background: "#fff",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "10px",
      padding: "5px",
      overflow: "auto",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
  },
  tab: {
    width: "33%",
    background: "",
    padding: "18px",
    background: "transparent",
    borderRadius: "40px",
    background: "transparent",
    transition: "0.3s ease",
    cursor: "pointer",
    "&.active": {
      color: "white",
      background:
        "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
    },
    "@media only screen and (max-width: 600px)": {
      minWidth: "max-content",
      padding: "10px 15px",
    },
  },
  tabCard: {
    marginTop: "65px",
    gap: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    "@media only screen and (max-width: 600px)": {
      marginTop: "30px",
      flexDirection: "column",
    },
  },
  tabCardLeftContainer: {
    width: "50%",
    display: "flex",
    gap: "40px",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      gap: "20px",
      width: "100%",
    },
  },
  tabCardRightContainer: {
    width: "50%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },

  tabListContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "30px",
    marginTop: "50px",
    "@media only screen and (max-width: 600px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  tabListItem: {
    display: "flex",
    width: "100%",
    margin: "0 auto",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    position: "relative",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      alignItems: "flex-start",
    },
  },
  tabListItemContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "10px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  wpFaq: {
    // paddingTop: "120px",
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },
  commonPageFooterSection: {
    background:
      " linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  accordianTabs: {
    backgroundImage: `url(${experienceBg})`,
    backgroundPosition: "top",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    position: "relative",
    "@media only screen and (max-width: 1024px)": {
      paddingBottom: "250px",
    },
    "@media only screen and (max-width: 768px)": {
      paddingBottom: "0",
    },

    "& .headercenterContainer": {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "64px",
      textAlign: "center",
      gap: "32px",
      "& h2": {
        width: "80%",
      },
      "& p": {
        width: "80%",
      },
      "@media (max-width:768px)": {
        flexDirection: "column",
        gap: "20px",
        marginBottom: "55px",
        "& h2": {
          width: "100%",
        },
        "& p": {
          width: "100%",
        },
      },
    },
  },
  experienceContainer: {
    position: "relative",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    "& .centerContainer": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      "@media only screen and (max-width: 1024px)": {
        width: "80%",
      },
      "@media only screen and (max-width: 768px)": {
        width: "90%",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
  },
  experienceInnerContainer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
    marginTop: "20px",
    gap: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
      alignItems: "center",
      marginTop: "0",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "20px",
      alignItems: "flex-start",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
    },
  },
  experienceContainerLeft: {
    width: "40%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "16px",
    "& .exp-desc": {
      marginBottom: "24px",
    },
    "& .view-more-link": {
      textDecoration: "underline",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      color: "#1D6FB6",
      marginBottom: "20px",
      "& img": {
        display: "inline-block!important",
        width: "16px!important",
        height: "16px",
        marginTop: "3px!important",
        transition: "transform 0.5s ease",
      },
      "&:hover": {
        color: "#010F1D",
        "& img": {
          transform: "translateX(5px)",
        },
      },
    },
    "@media only screen and (max-width: 1024px)": {
      width: "50%",
      gap: "20px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      gap: "24px",
      alignItems: "center",
      textAlign: "center",
      "& .exp-desc": {
        marginBottom: "16px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginTop: "0px",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "18px",
    },
  },
  experienceContainerRight: {
    width: "45%",
    "& img": {
      width: "100%",
      height: "100%",
    },
    "@media only screen and (max-width: 768px)": {
      display: "none",
    },
  },
  faqBoxAccordian: {
    padding: "0 16px",
    // backgroundColor: "#fff",
    borderRadius: "16px",
    position: "relative",
    transition: "all 0.3s ease",
    cursor: "pointer",
    "& h3": {
      color: "#0A2035",
      opacity: "0.7",
    },
    "&:after": {
      content: '""',
      position: "absolute",
      left: "0",
      top: "0",
      width: "2px",
      height: "100%",
      background: "rgba(255, 255, 255, 0.2)",
    },
    "&:before": {
      content: '""',
      position: "absolute",
      background: "#B1DBFF",
      background:
        "linear-gradient(180deg,rgba(177, 219, 255, 1) 16%, rgba(0, 137, 255, 1) 75%, rgba(0, 137, 255, 1) 80%)",
      left: "-1px",
      top: "0",
      width: "4px",
      height: "100%",
      transform: "scaleY(0)",
      transformOrigin: "top",
      zIndex: 1,
    },
    "&.active": {
      "& h3": {
        color: "#0A2035",
        opacity: "1",
      },
      "&:before": {
        animation: "growTimer 10s linear forwards", // Same as JS interval
      },
    },
    "& .body": {
      margin: "0",
    },
    "& .exp-desc": {
      margin: "10px 0 16px",
    },
  },
  experienceHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    cursor: "pointer",
    gap: "12px",
  },
  collapseBody: {
    margin: "0",
    paddingLeft: "50px",
    // "& div": {
    //   display: "flex",
    //   alignItems: "flex-start",
    //   justifyContent: "flex-start",
    //   gap: "12px",
    // },

    // "& .emptySpace": {
    //   minWidth: "36px",
    // },
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 1024px)": {
      margin: "8px 0 0",
    },
    "@media only screen and (max-width: 768px)": {
      margin: "6px 0 0",
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "12px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      margin: "5px 0 0",
      "& img": {
        marginTop: "10px",
      },
    },
  },
}));

const CustomerSupportAiCrm = () => {
  const classes = useStyles();
  const [activeRealWorld, setActiveRealWorld] = useState(0);
  const [activeAccordian, setActiveAccordian] = useState(0);
  const sectionRef = useRef(null);

  const featureList1 = [
    {
      title: "AI-powered chatbot",
      desc: "Resolve common customer queries instantly with 24/7 AI-driven conversations.",
      icon: keyIcon1,
    },
    {
      title: "Smart ticket routing",
      desc: "Automatically assign incoming queries to the most suitable support agent. This ensures faster resolution.",
      icon: keyIcon2,
    },
    {
      title: "Sentiment analysis",
      desc: "Detect and analyse customer emotions during conversations in real time. Prioritise urgent or sensitive cases.",
      icon: keyIcon3,
    },
  ];

  const featureList2 = [
    {
      title: "Auto-responses & templates",
      desc: "Speed up replies with intelligent suggestions and customisable templates. Pepper Cloud CRM support tools.",
      icon: keyIcon4,
    },
    {
      title: "Unified customer view",
      desc: "Access the complete history of conversations, preferences, and tickets in one place.",
      icon: keyIcon5,
    },
    {
      title: "Multichannel support",
      desc: "Engage customers across WhatsApp, email, live chat, and more from a single platform.",
      icon: keyIcon6,
    },
  ];
  const benefits = [
    {
      title: "24/7 availability",
      desc: "Never miss a customer query again—Pepper Cloud AI CRM offers round-the-clock support across email, WhatsApp, and live chat. Your customers get instant responses, even outside business hours.",
      icon: benefitIcon1,
    },
    {
      title: "Faster response times",
      desc: "With intelligent auto-replies and AI-suggested responses built into your CRM support tools, your team can resolve queries in seconds, not hours—improving overall response SLAs.",
      icon: benefitIcon2,
    },
    {
      title: "Reduced ticket volume",
      desc: "The AI automatically handles routine requests, FAQs, and basic troubleshooting. This keeps your inbox lighter and ensures your CRM customer support team is focused only on complex issues.",
      icon: benefitIcon3,
    },
    {
      title: "Improved team productivity",
      desc: "By automating repetitive tasks and offering real-time assistance, Pepper Cloud enables your CRM for customer support teams to spend more time on meaningful interactions and escalations.",
      icon: benefitIcon4,
    },
    {
      title: "Increased customer satisfaction",
      desc: "Deliver consistent, personalised service across all channels using AI-driven workflows. Faster resolutions and smarter communication lead to happier, more loyal customers.",
      icon: benefitIcon5,
    },
    {
      title: "Smarter insights",
      desc: "Use AI-powered analytics to monitor performance, track trends, and identify improvement areas. These insights help refine your customer support CRM strategy and elevate the service experience.",
      icon: benefitIcon6,
    },
  ];
  const partners = [
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
  ];

  const tabContentData = [
    {
      tabContent: [
        {
          title: "Order resolutions made easy",
          content:
            "AI summaries help your CRM customer support agents answer product and delivery queries faster.",
          alt: "WhatsApp CRM for customer service",
        },
        {
          title: "Automated updates",
          content:
            " Share real-time order, shipping, and return details across WhatsApp, email, and chat.",
          alt: "WhatsApp CRM for customer service",
        },
        {
          title: "Smart follow-ups",
          content:
            " Convert abandoned cart chats into tasks using AI-driven workflows.",
          alt: "WhatsApp CRM for customer service",
        },
        {
          title: "Product discovery",
          content:
            "Recommend products and push catalogues directly through the CRM support dashboard.",
          alt: "WhatsApp CRM for customer service",
        },
      ],
      img: realWorldImg1,
      alt: "WhatsApp CRM for customer service",
      subtitle:
        "Enhance post-purchase experience and build customer loyalty with faster, AI-driven responses.",
    },
    {
      tabContent: [
        {
          title: "Admission follow-ups",
          content:
            " The AI automatically detects inquiry intent and reminds your team of the next steps.",
          alt: "AI CRM for Education",
        },
        {
          title: "Query summaries",
          content:
            " Teachers and counsellors get quick overviews of messages from parents or students.",
          alt: "AI CRM for Education",
        },
        {
          title: "Centralised content",
          content:
            " Find brochures, curriculum documents, and past chats easily within the CRM for customer support teams.",
          alt: "AI CRM for Education",
        },
        {
          title: "Custom replies",
          content:
            " Conversational AI crafts accurate, student-specific responses based on previous interactions.",
          alt: "AI CRM for Education",
        },
      ],
      img: realWorldImg2,
      alt: "AI CRM for Education",
      subtitle:
        "Simplify student communication, admission queries, and academic support using AI.",
    },
    {
      tabContent: [
        {
          title: "Appointment coordination",
          content:
            " AI turns booking or rescheduling messages into follow-up tasks.",
          alt: "AI CRM for Healthcare",
        },
        {
          title: "Instant summaries",
          content:
            " Doctors and admins can quickly scan through patient concerns without reading entire threads.",
          alt: "AI CRM for Healthcare",
        },
        {
          title: "Access patient history",
          content:
            " Find previous messages and health interactions inside the customer support CRM.",
          alt: "AI CRM for Healthcare",
        },
        {
          title: "Quick assistance",
          content:
            " Use AI-suggested replies to handle FAQs and emergency messages promptly.",
          alt: "AI CRM for Healthcare",
        },
      ],
      img: realWorldImg3,
      alt: "AI CRM for Healthcare",
      subtitle:
        "Support patient engagement and operational efficiency with AI-powered automation.",
    },
    {
      tabContent: [
        {
          title: "Booking updates",
          content:
            " AI shares real-time itinerary changes, confirmations, and policy info automatically.",
          alt: "AI CRM for Travel & Hospitality",
        },
        {
          title: "Trip inquiries simplified",
          content:
            " Summarised conversations help staff assist faster and more effectively.",
          alt: "AI CRM for Travel & Hospitality",
        },
        {
          title: "Automated reminders",
          content:
            "Automated reminders: From check-ins to special requests, AI ensures no task is missed.",
          alt: "AI CRM for Travel & Hospitality",
        },
        {
          title: "Cross-channel support",
          content:
            "Cross-channel support: Manage all guest conversations from WhatsApp, email, and chat in one CRM customer support platform.",
          alt: "AI CRM for Travel & Hospitality",
        },
      ],
      img: realWorldImg4,
      alt: "AI CRM for Travel & Hospitality",
      subtitle:
        "Deliver seamless guest experiences before, during, and after travel.",
    },
    {
      tabContent: [
        {
          title: "Intent-based tagging",
          content:
            "AI highlights high-intent buyers and flags follow-up priorities.",
          alt: "AI CRM for Real Estate",
        },
        {
          title: "Property info delivery",
          content:
            " Instantly send brochures, pricing, and availability from within the CRM.",
          alt: "AI CRM for Real Estate",
        },
        {
          title: "Task automation",
          content:
            " Schedule site visits, document collection, and negotiations with AI-driven workflows.",
          alt: "AI CRM for Real Estate",
        },
        {
          title: "Complete conversation view",
          content:
            " Keep track of every buyer interaction in one unified CRM support dashboard.",
          alt: "AI CRM for Real Estate",
        },
      ],
      img: realWorldImg5,
      alt: "AI CRM for Real Estate",
      subtitle:
        "Qualify leads faster and manage buyer communication efficiently with AI.",
    },
  ];
  const faqs = [
    {
      question: "How can AI support customer service?",
      answer:
        "AI enhances customer service by automating routine tasks, providing instant responses, and offering personalised support at scale. Integrated into a customer support CRM, AI can handle FAQs, summarise conversations, route tickets to the right agents, and suggest relevant replies—helping CRM customer support teams work faster and more efficiently.",
    },
    {
      question: "Which CRM is best for customer service?",
      answer:
        "The best CRM for customer support is one that combines automation, multichannel communication, and real-time intelligence. Pepper Cloud stands out as a top choice, offering an AI-powered CRM support platform that enables faster responses, smart ticket routing, and seamless collaboration across WhatsApp, email, and chat.",
    },
    {
      question: "How can AI help with customer support?",
      answer:
        "AI helps by reducing the workload on support teams and ensuring quicker resolutions. Within a modern CRM for customer support teams, AI can automatically respond to common queries, prioritise tickets based on sentiment, and generate smart follow-ups—improving both team productivity and customer satisfaction.",
    },
    {
      question: "Will AI replace customer service?",
      answer:
        "AI won’t replace customer service, but it will redefine it. AI handles repetitive queries and assists with workflows, allowing human agents to focus on complex, high-touch interactions. When used within a smart customer support CRM, AI becomes a powerful assistant—not a replacement—for your support team.",
    },
    {
      question: "What makes Pepper Cloud the best CRM for customer support?",
      answer:
        "Pepper Cloud combines AI capabilities with a user-friendly interface, multichannel integration, and automation to help support teams resolve queries faster and more efficiently.",
    },
    {
      question: "Is Pepper Cloud AI CRM suitable for small businesses?",
      answer:
        "Absolutely. Our AI CRM is built for businesses of all sizes, with scalable features that grow as you grow.",
    },
    {
      question: "How secure is the customer data in Pepper Cloud CRM?",
      answer:
        "We follow strict data security protocols and are compliant with global standards to ensure your customer data is always protected.",
    },
  ];
  const experienceList = [
    {
      title: "No limits on growth",
      alt: "Scalable CRM for customer support",
      img: experienceImg2,
      icon: expIcon1,
      desc: "Whether you're a small team or an expanding support centre, Pepper Cloud grows with you. Add unlimited users, teams, and documents—our CRM for customer support teams scales effortlessly.",
    },
    {
      title: "Built inside the CRM",
      alt: "AI features natively embedded in CRM",
      img: experienceImg3,
      icon: expIcon2,
      desc: "All AI features are natively embedded within the platform. Use AI-suggested replies in chats, emails, and tasks without ever leaving your CRM support environment.",
    },
    {
      title: "Works with WhatsApp, email, and web",
      alt: "Omnichannel customer support CRM",
      img: experienceImg4,
      icon: expIcon3,
      desc: "Engage with your customers across multiple channels from a single shared inbox. Deliver seamless CRM customer support across WhatsApp, email, and live chat—fully integrated.",
    },
    {
      title: "Smart workflows with AI help",
      alt: "AI-powered workflow automation",
      img: experienceImg5,
      icon: expIcon4,
      desc: "Automate daily support tasks like ticket updates, follow-ups, and escalations. Let AI suggest next steps and personalise actions to streamline your team’s workflow.",
    },
    {
      title: "Live support from agentic AI",
      alt: "Real-time AI guidance for support agents",
      img: experienceImg6,
      icon: expIcon5,
      desc: "Empower your support agents with real-time AI guidance. Get intelligent recommendations, lead scores, and contextual tips that help resolve issues faster and boost customer satisfaction.",
    },
  ];
  const AUTO_PLAY_INTERVAL = 10000;

  useEffect(() => {
    let interval;

    const startAutoplay = () => {
      clearInterval(interval);
      interval = setInterval(() => {
        setActiveAccordian((prev) => (prev + 1) % experienceList.length);
      }, AUTO_PLAY_INTERVAL);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          startAutoplay();
        } else {
          clearInterval(interval);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      clearInterval(interval);
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [experienceList.length]);

  return (
    <main>
      <SEO
        title={
          "AI CRM for Customer Support | Smarter, Faster, Personalized Service"
        }
        pathname={"https://peppercloud.com/ai-crm-for-customer-support/"}
        keywords="AI CRM for customer support, AI customer support CRM, Customer support AI CRM, AI CRM dashboard view, Smart customer support CRM, AI chatbot support system, Automated customer service CRM, AI-powered CRM software"
        description={
          "Empower your support team with the best AI CRM for customer support. Upgrade your support process with an AI customer support CRM — streamline workflows, predict customer needs, and improve satisfaction with automation."
        }
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is an AI CRM for sales?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "An AI CRM for sales uses artificial intelligence to manage leads, automate tasks, and assist sales reps with smart suggestions, summaries, and chat automation.",
                },
              },
              {
                "@type": "Question",
                name: "How does AI within CRM help sales representatives?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "It saves time by automating repetitive tasks, writing follow-ups, summarising chats, and helping reps prioritise leads with AI-powered scoring.",
                },
              },
              {
                "@type": "Question",
                name: "Is Pepper Cloud suitable for small businesses?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, Pepper Cloud is built for small and medium teams, with scalable plans, intuitive design, and 24/7 support.",
                },
              },
              {
                "@type": "Question",
                name: "Can I use Pepper Cloud on mobile?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Absolutely. Pepper Cloud’s mobile app lets you manage deals, customers, and chats on the go.",
                },
              },
              {
                "@type": "Question",
                name: "What integrations does Pepper Cloud support?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "You can plug in tools like Gmail, Zoom, Outlook, Mailchimp, Aircall, Xero, and more with just a few clicks.",
                },
              },
              {
                "@type": "Question",
                name: "How does AI within CRM help sales?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "AI within CRM automates tasks, prioritises leads, and offers real-time insights to help sales reps focus on closing deals. It boosts productivity and improves follow-ups using smart recommendations.",
                },
              },
              {
                "@type": "Question",
                name: "Which AI tool is best for sales?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud is the best AI CRM for sales, offering AssistAI, omnichannel messaging, and predictive insights. It’s built for teams that want to sell smarter and faster.",
                },
              },
            ],
          },
        ]}
      />
      <div className={classes.heroSectionOuter}>
        <section className={classes.heroSection}>
          <div className="container">
            <div className={classes.heroSectionContainer}>
              <div className={classes.leftContainer}>
                <div className={classes.leftBody}>
                  <motion.h1
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-wix-semibold font-64 font-white"
                  >
                    Revolutionise <span>customer support</span> with AI CRM
                  </motion.h1>
                  <p className="font-white font-20 font-wix-regular mb20">
                    Empower your support teams with Pepper Cloud’s AI-powered
                    customer support CRM that understands your customers,
                    responds instantly, and resolves queries at scale.
                  </p>
                  <Link
                    className="primaryButton font-20 font-wix-medium font-white"
                    to="/contact/"
                  >
                    Book a free demo
                  </Link>
                </div>
              </div>
              <div className={classes.rightContainer}>
                <div className={classes.boxes}>
                  <div className={classes.box}>
                    <img src={heroIcon1} alt="AI CRM for customer support" />
                    <p className="font-18 font-wix-medium font-white">
                      Auto-assign tickets
                    </p>
                  </div>
                  <div className={classes.box}>
                    <img src={heroIcon2} alt="Customer support AI CRM" />
                    <p className="font-18 font-wix-medium font-white">
                      Multichannel integration
                    </p>
                  </div>
                  <div className={classes.box}>
                    <img src={heroIcon3} alt="AI CRM for customer support" />
                    <p className="font-18 font-wix-medium font-white">
                      Smart ticket routing
                    </p>
                  </div>
                </div>
                <LazyImage
                  source={heroSectionImg}
                  width={"100%"}
                  className={"heroSectionImg"}
                  alt="Customer support AI CRM"
                />
              </div>
            </div>
          </div>
        </section>
        <section className={classes.bannerSection}>
          <div className="container">
            <img src={bannerImg} alt="AI CRM for Customer Support" />
          </div>
        </section>
        <section className={classes.cardsSection}>
          <div className="container">
            <div className="centerContainer">
              <motion.h2
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-semibold font-56 font-white"
              >
                How AI transforms customer support CRM
              </motion.h2>
            </div>
            <div className={classes.cards}>
              <div className={classes.card}>
                <div className={classes.cardLeftContainer}>
                  <motion.h3
                    initial={{ opacity: 1, x: -40 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-wix-semibold font-48 font-white"
                  >
                    AI CRM resolves 80% of customer service requests
                  </motion.h3>
                  <motion.p
                    initial={{ opacity: 1, x: -40 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-wix-regular font-16 font-white"
                  >
                    Pepper Cloud’s AI-powered customer support CRM can resolve
                    up to 80% of routine queries automatically. By managing
                    FAQs, order updates, and basic troubleshooting it reduces
                    the load on your support agents. This smart CRM for customer
                    support teams ensures faster responses and improved customer
                    satisfaction. Trusted by growing businesses, it’s the best
                    CRM for customer support to scale service efficiently.
                  </motion.p>
                </div>
                <div className={classes.cardRightContainer}>
                  <LazyImage
                    source={cardImg1}
                    width={"100%"}
                    alt="Personalized support CRM"
                  />
                </div>
              </div>
              <div className={classes.card}>
                <div className={classes.cardRightContainer}>
                  <LazyImage
                    source={cardImg2}
                    width={"100%"}
                    alt="AI CRM insights"
                  />
                </div>
                <div className={classes.cardLeftContainer}>
                  <motion.h3
                    initial={{ opacity: 1, x: -40 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-wix-semibold font-48 font-white"
                  >
                    What is AI CRM for customer support?
                  </motion.h3>
                  <motion.p
                    initial={{ opacity: 1, x: -40 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-wix-regular font-16 font-white"
                  >
                    AI CRM for customer support is a powerful blend of
                    automation, intelligence, and personalisation. It combines
                    the capabilities of a traditional CRM support platform with
                    artificial intelligence to help support teams respond
                    faster, anticipate needs, and personalise every interaction.
                    Whether it’s resolving common issues, routing tickets, or
                    offering instant replies via chat, AI CRM is transforming
                    how support teams operate.
                  </motion.p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <section className={classes.keyFeature}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-black1"
            >
              Key features of Pepper Cloud AI CRM for customer support
            </motion.h2>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-regular font-20 font-black1"
            >
              Designed specifically for customer support CRM needs, Pepper Cloud
              equips teams with cutting-edge tools to streamline operations and
              enhance customer satisfaction.
            </motion.p>
          </div>
          <div className={classes.keyFeatureContainer}>
            <div className={classes.keyBlock}>
              {featureList1.map((feature) => (
                <div className={classes.keyBox}>
                  <img src={feature.icon} alt="Smart customer support CRM" />
                  <p className="font-wix-semibold font-24 font-black2">
                    {feature.title}
                  </p>
                  <p className="font-wix-regular font-18 font-black4">
                    {feature.desc}
                  </p>
                </div>
              ))}
            </div>
            <img
              src={keyImg}
              className="keyImg"
              alt="Customer issue tracking AI CRM"
            />
            <div className={classes.keyBlock}>
              {featureList2.map((feature) => (
                <div className={classes.keyBox}>
                  <img src={feature.icon} />
                  <p className="font-wix-semibold font-24 font-black2">
                    {feature.title}
                  </p>
                  <p className="font-wix-regular font-18 font-black4">
                    {feature.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className={classes.accordianTabs}>
        <div className="container">
          <div className="headercenterContainer">
            <motion.h2
              className="font-wix-semibold font-56 font-white"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Pepper Cloud: The best CRM for customer support
            </motion.h2>
            <p className="font-18 font-wix-regular font-white">
              Pepper Cloud blends Generative AI, Assistive AI, and
              Conversational AI to deliver a powerful customer support CRM. It
              helps your team respond quickly, automate repetitive tasks, and
              offer consistent, high-quality service—without switching tools.
            </p>
          </div>
          <div className={classes.experienceInnerContainer}>
            <div className={classes.experienceContainerRight}>
              {experienceList.map(
                (experience, index) =>
                  index === activeAccordian && (
                    <motion.img
                      alt="Customer issue tracking AI CRM"
                      initial={{ opacity: 1, y: 20 }}
                      src={experience.img}
                      transition={{ duration: 0.3 }}
                      whileInView={{ opacity: 1, y: 0 }}
                    />
                  )
              )}
            </div>
            <div className={classes.experienceContainerLeft} ref={sectionRef}>
              {experienceList.map((faq, index) => (
                <motion.div
                  className={clsx(
                    classes.faqBoxAccordian,
                    index === activeAccordian && "active",
                    "text-color2"
                  )}
                  key={`faq-${index}-${activeAccordian === index}`}
                  onClick={() => setActiveAccordian(index)}
                  transition={{ duration: 1, delay: index * 0.01 }}
                  whileInView={{ opacity: [0, 1], y: [50, 0] }}
                >
                  <div className={classes.experienceHeader}>
                    <img src={faq.icon} alt="AI-driven customer support" />
                    <h3 className="font-20 font-wix-semibold font-white">
                      {faq.title}
                    </h3>
                  </div>
                  <Collapse
                    className={classes.collapseBody}
                    in={activeAccordian === index}
                  >
                    <div className="emptySpace" />
                    <p className="font-18 font-wix-regular font-white exp-desc">
                      {faq.desc}
                    </p>
                    <motion.img
                      alt="AI-driven customer support"
                      initial={{ opacity: 1, y: 20 }}
                      src={faq.img}
                      transition={{ duration: 0.3 }}
                      whileInView={{ opacity: 1, y: 0 }}
                    />
                  </Collapse>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className={classes.benefitSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-black1"
            >
              Benefits of AI CRM for customer support
            </motion.h2>
          </div>
          <div className={classes.benefitContainer}>
            {benefits.map((benefit) => (
              <div className={classes.benefitBox}>
                <img
                  src={benefit.icon}
                  alt="Customer support automation tool"
                />
                <p className="font-wix-semibold font-20 font-black1">
                  {benefit.title}
                </p>
                <p className="font-wix-regular font-16 font-black4">
                  {benefit.desc}
                </p>
              </div>
            ))}
          </div>
          <div className="trustedHeading">
            <motion.h3
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-24 font-black1"
            >
              Trusted by leading businesses for outstanding efficiency
            </motion.h3>
          </div>
        </div>

        <Swiper
          className={classes.partnerSlider}
          slidesPerView="auto"
          spaceBetween={60}
          loop={true}
          speed={2000}
          modules={[Autoplay]}
          allowTouchMove={false}
          autoplay={{
            delay: 100,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}
        >
          {partners.map((partner) => (
            <SwiperSlide className={classes.partnerSlide}>
              <img src={partner.icon} alt={partner.alt} />
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <section className={classes.tabsSection}>
        <div className={classes.absoulteCard}>
          <TruestedSection shadow={true} background={true} />
        </div>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-white"
            >
              Application and use cases for customer support
            </motion.h2>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-regular font-20 font-white"
            >
              AI CRM is transforming how businesses across industries deliver
              timely, consistent, and personalised support. With intelligent
              customer support CRM of Pepper Cloud, you can automate
              conversations, streamline ticket handling, and elevate customer
              satisfaction across every touchpoint.
            </motion.p>
            <div className={classes.tabsContainer}>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 0 && "active"
                )}
                onClick={() => setActiveRealWorld(0)}
              >
                E-commerce
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 1 && "active"
                )}
                onClick={() => setActiveRealWorld(1)}
              >
                Education
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 2 && "active"
                )}
                onClick={() => setActiveRealWorld(2)}
              >
                Healthcare
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 3 && "active"
                )}
                onClick={() => setActiveRealWorld(3)}
              >
                Travel and hospitality
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 4 && "active"
                )}
                onClick={() => setActiveRealWorld(4)}
              >
                Real estate
              </div>
            </div>
          </div>
          <div className={classes.tabCard}>
            <div className={classes.tabCardLeftContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <div>
                      <motion.p
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.3 }}
                        className="font-wix-regular font-18 font-white"
                      >
                        {listItem.subtitle}
                      </motion.p>
                      <div className={classes.tabListContainer}>
                        {listItem.tabContent.map((item) => (
                          <motion.div
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.3 }}
                            className={classes.tabListItem}
                          >
                            <LazyImage
                              source={greenCheckCircle}
                              className={classes.tabIcon}
                              alt={item.alt}
                            />
                            <div className={classes.tabListItemContent}>
                              <p className="font-wix-semibold font-18 font-white">
                                {item.title}:
                              </p>
                              <p className="font-wix-regular font-16 font-white">
                                {item.content}
                              </p>
                            </div>
                          </motion.div>
                        ))}
                      </div>
                    </div>
                  )
              )}
            </div>
            <div className={classes.tabCardRightContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <motion.div
                      initial={{ opacity: 1, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3 }}
                      // className={classes.aiSectionRight}
                    >
                      <LazyImage
                        source={listItem.img}
                        alt="CRM with AI support"
                        width={"100%"}
                      />
                    </motion.div>
                  )
              )}
            </div>
          </div>
        </div>
      </section>
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#FFFFFF"}
          heading={"Frequently asked questions for customer support CRM"}
          faqs={faqs}
        />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-medium font-56 font-white"
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Smarter customer support starts here
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
            >
              Get started
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default CustomerSupportAiCrm;
